import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AgentGroup } from 'src/app/core/models/agent-group';
import { PaginatedResults } from 'src/app/core/models/paginated_results_model';
import { PaginationOptions } from 'src/app/core/models/pagination_options';
import { AgentGroupService } from 'src/app/core/services/agent-group.service';

@Component({
  selector: 'app-search-agent-group',
  templateUrl: './search-agent-group.component.html',
  styleUrls: ['./search-agent-group.component.scss']
})
export class SearchAgentGroupComponent {
  public loading = true;
  public initialLoading = true;
  public agentGroupsList!: Array<AgentGroup>;
  public paginatedResults!: PaginatedResults;
  public paginationOptions = new PaginationOptions(
    { sort: 'agent_group_number', direction: 'asc' },
    'agent_groups'
  );

  public sortColumns = [
    'agent_group_number',
    'company_name',
    'details',
    'street_address',
    'city',
    'country',
    'phone_number',
    'email',
    'bank_name',
    'bank_code',
    'bank_branch',
    'bank_account_name',
    'bank_account_number',
    'tax_certificate_number',
  ];


  constructor(
    private router: Router,
    private agentGroupService: AgentGroupService,
    public activeModal: NgbActiveModal
  ) { }

  ngAfterViewInit(): void {
    this.search();
  }

  search() {
    this.loading = true;
    this.agentGroupService
      .search(this.paginationOptions)
      .subscribe((res: PaginatedResults) => {
        this.paginatedResults = res;
        this.agentGroupsList = res.data.map((u) => new AgentGroup(u));
        this.initialLoading = false;
        this.loading = false;
      });
  }

  select(agentGroup: AgentGroup) {
    this.activeModal.close(agentGroup);
  }

  toggleFilter() {
    this.paginationOptions.toggleFilter();
    this.paginatedResults.current_page = 1;
    this.onPageNumberChanged();
  }

  onPageNumberChanged() {
    this.paginationOptions.pageNumber = this.paginatedResults.current_page;
    this.paginationOptions.saveUpdatedOptions();
    this.onPaginationChanged();
  }

  onPerPageChanged() {
    this.paginatedResults.current_page = 1;
    this.paginationOptions.perPage = this.paginatedResults.per_page;
    this.paginationOptions.pageNumber = this.paginatedResults.current_page;
    this.onPageNumberChanged();
  }

  changeSort(field: any) {
    if (this.paginationOptions.sort === field) {
      this.paginationOptions.toggleDirection();
    } else {
      this.paginationOptions.sort = field;
      this.paginationOptions.resetDirection();
    }

    this.paginatedResults.current_page = 1;
    this.paginationOptions.pageNumber = this.paginatedResults.current_page;
    this.onPageNumberChanged();
  }

  onPaginationChanged() {
    this.search();
  }
}
